import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderStopTable extends Layout {
    sourceStop: DataSource;
    tableStop: Table;
}
